import useSocket from "hooks/useSocket";
import React, { createContext } from "react";

export const SocketContext = createContext(null);
const apiUrlMiror = process.env.REACT_APP_API_MIROR_URL;
export const SocketProvider = ({ children }) => {
  const { socket, isConnected } = useSocket(apiUrlMiror, {
    withCredentials: true,
    transports: ["websocket"],
    reconnectionAttempts: 3,
    reconnectionDelay: 1000,
  });

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
